export const RESIZE_RENDER_DELAY = 200; // ms
